import { assetImages } from "constants";

const EmptyDataView = ({ moduleName = "" }) => {
  return (
    <div className="empty_access text-center">
      <div className="empty_pic mb-4">
        {" "}
        <img src={assetImages.emptyVector} alt="" />
      </div>
      <div className="empty_text">
        <p className="fs-lg text-gray fw-semibold mb-4">
          Sorry....! {moduleName} are not available at this moment
        </p>
      </div>
    </div>
  );
};

export default EmptyDataView;
